import React, { useContext, useEffect } from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";

import ScalingContext from "../../../../../../context/scaling/ScalingContext";

export default function CampaignTableDetails(props) {
  const { tableWidth, campaign, language_name } = props;

  const useStyles = makeStyles((theme) => ({
    tableCell: {
      borderBottom: `1px solid ${theme.palette.text.disabled}`,
    },
  }));
  const classes = useStyles();

  const { scaling_status_options, scaling_status, setScalingStatus } =
    useContext(ScalingContext);

  // Variable: Set Mode If Is Editing
  const edit_mode = tableWidth === "100%";

  // Functions: Format Number Value
  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });

  const StyledHeaderCell = (width, align, value) => (
    <TableCell width={width} align={align} className={classes.tableCell}>
      {" "}
      {value}{" "}
    </TableCell>
  );

  const StyledCell = (align, value) => (
    <TableCell align={align} className={classes.tableCell}>
      {" "}
      {value}{" "}
    </TableCell>
  );

  useEffect(() => {
    // Function: Initialize Scaling Status Variable
    if (edit_mode && campaign) {
      if (campaign.scaling_status) {
        setScalingStatus(campaign.scaling_status);
      } else {
        setScalingStatus("TESTING");
      }
    }
  }, [edit_mode, campaign]);

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            {" "}
            {StyledHeaderCell("10%", "left", "Laptop")}{" "}
            {StyledHeaderCell("13%", "left", "Angle")}{" "}
            {StyledHeaderCell("8%", "center", "Media Buyer")}{" "}
            {StyledHeaderCell("8%", "center", "Language")}{" "}
            {StyledHeaderCell("6%", "center", "VAPT")}{" "}
            {StyledHeaderCell("13%", "center", "Scaling Status")}{" "}
            {StyledHeaderCell("8%", "right", "Revenue")}{" "}
            {StyledHeaderCell("8%", "right", "Cost")}{" "}
            {StyledHeaderCell("8%", "right", "Profit")}{" "}
            {StyledHeaderCell("6%", "right", "ROAS")}{" "}
            {StyledHeaderCell("6%", "right", "CTR")}{" "}
            {StyledHeaderCell("6%", "right", "CV")}{" "}
          </TableRow>{" "}
        </TableHead>
        <TableBody>
          <TableRow>
            {" "}
            {StyledCell("left", campaign.laptop)}{" "}
            {StyledCell("left", campaign.angle)}{" "}
            {StyledCell("center", campaign.media_buyer)}{" "}
            {StyledCell("center", language_name)} {StyledCell("center", 0)}{" "}
            {edit_mode && scaling_status ? (
              <TableCell className={classes.tableCell}>
                <TextField
                  margin="dense"
                  size="small"
                  fullWidth
                  required
                  id="name"
                  select
                  SelectProps={{
                    native: true,
                  }}
                  onChange={(e) => setScalingStatus(e.target.value)}
                  value={scaling_status}
                >
                  {scaling_status_options.map((value, index) => (
                    <option key={index} value={value}>
                      {" "}
                      {value}{" "}
                    </option>
                  ))}{" "}
                </TextField>{" "}
              </TableCell>
            ) : (
              StyledCell("center", campaign.scaling_status)
            )}{" "}
            {StyledCell("right", currencyFormatter.format(campaign.revenue))}{" "}
            {StyledCell("right", currencyFormatter.format(campaign.cost))}{" "}
            {StyledCell(
              "right",
              <span
                style={{
                  color:
                    +campaign.profit < 0
                      ? "red"
                      : +campaign.profit > 0
                      ? "green"
                      : "black",
                }}
              >
                {currencyFormatter.format(campaign.profit)}{" "}
              </span>
            )}{" "}
            {StyledCell("right", campaign.ROAS)}{" "}
            {StyledCell("right", `${campaign.CTR}%`)}{" "}
            {StyledCell("right", `${campaign.CV}%`)}{" "}
          </TableRow>{" "}
        </TableBody>{" "}
      </Table>{" "}
    </TableContainer>
  );
}
